module.exports = __webpack_public_path__ + "img/time_square.fc4c3c8a.svg";